import script from "./view-default-notfound.vue?vue&type=script&setup=true&lang=js"
export * from "./view-default-notfound.vue?vue&type=script&setup=true&lang=js"

import "./view-default-notfound.vue?vue&type=style&index=0&id=317cc862&scoped=true&lang=css"

import exportComponent from "C:\\FileServer\\vedwen\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-317cc862"]])

export default __exports__